export const breakpoints = {
    mobileMax: "460px",
    tabletMin: "461px",
    mobileBigMax: "720px",
    tabletBigMin: "721px",
    tabletMax: "1150px",
    desktopMin: "1151px",
    desktopBigMin: "1420px",
};
